export default function cacheableAccessor<T>(callback: () => T): () => T {
    let cache: T;
    let executed = false;

    return () => {
        if (!executed) {
            cache = callback();
            executed = true;
        }

        return cache;
    };
}
